export enum AdminFeatureEnum {
  DIGITAL_SHARING = "digital_sharing",
  EXTENDED_STORAGE = "extended_storage",
  WHATSAPP_SHARING = "whatsapp_sharing",
  CUSTOMISED_COLUMNS = "customised_columns",
  CASE_OPENED = "case_opened",
  DOCTOR_REASSIGN = "doctor_reassign",
  SHOW_REPORTED_TIME = "show_reported_time",
  VIEWER_LOAD_ALL_SERIES = "viewer_load_all_series",
  VOICE_TO_TEXT = "voice_to_text",
  AI_REPORTING = "ai_reporting",
  /** Tenant uses OpenAI (e.g. GPT-5.4) for AI-assisted reporting instead of Gemini. */
  OPENAI = "openai",
}
